import { useLaboratorioAnalise } from "@/hooks/useLaboratorioAnalise";
import { Checkbox, Col, DatePicker, Form, Input, Row, Select } from "antd";

export function FormDadosGerais() {
  const { laboratoriosOptions } = useLaboratorioAnalise();

  return (
    <>
      <Row gutter={[8, 8]}>
        <Col xs={24} sm={12}>
          <Form.Item
            name={["laboratorio", "id"]}
            label="Laboratório"
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Selecione o Laboratorio"
              showSearch
              filterSort={(optionA, optionB) =>
                (optionA?.label ?? "")
                  .toLowerCase()
                  .localeCompare((optionB?.label ?? "").toLowerCase())
              }
              optionFilterProp="label"
              options={laboratoriosOptions}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item name="numRegistroLaboratorio" label="Nº Registro">
            <Input placeholder="Informe o Nº do Registro do Laboratorio" />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item name="dataRecebimento" label="Data Recebimento">
            <DatePicker
              placeholder="Selecione a Data de Recebimento"
              format={"DD/MM/YYYY"}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item
            name={"amostraImpropria"}
            label={" "}
            valuePropName="checked"
          >
            <Checkbox>Amostra Imprória</Checkbox>
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item
            name="observacaoRecebimento"
            label="Observação Recebimento"
          >
            <Input.TextArea placeholder="Informe as Observações" rows={4} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}
